/**
 * Display gate for accreditation.
 *
 * A missing flag, or any value other than false, keeps today's display.
 * False hides the Accredited badge, the comparison Yes, and the printed
 * accreditor name. The stored accreditor string is left in place.
 */
export function isAccreditationHidden(stats: unknown): boolean {
  if (stats === null || typeof stats !== 'object') {
    return false;
  }
  const entry = (stats as { showAccreditation?: unknown }).showAccreditation;
  if (entry === null || typeof entry !== 'object') {
    return false;
  }
  return (entry as { value?: unknown }).value === false;
}

export function isAdditionalAccreditationHidden(additional: unknown): boolean {
  if (additional === null || typeof additional !== 'object') {
    return false;
  }
  return (
    (additional as { showAccreditation?: unknown }).showAccreditation === false
  );
}

export function shouldShowAccreditationBadge(
  accreditator: string | null | undefined,
  stats: unknown,
): boolean {
  return Boolean(accreditator) && !isAccreditationHidden(stats);
}
